import {IAllUsersAPIResponse} from './usersSlice';
import { HttpRequest } from '../../../util/http';


export const getAllUsers = () => {
  return new Promise<IAllUsersAPIResponse>((resolve) => {
    const method = 'get';

    HttpRequest.fetch<IAllUsersAPIResponse>('/scripts/clientUsers', {
      method,
    }).then((res) => resolve(res));
  });
};




